/* plugins/myPlugin.js 自定义插件 */

import { post, get, passwordMd5, Base_Url, Base_Upload_Url } from "./index.js";

// 自定义插件
export default {
  install: (Vue) => {
    // Vue 混入成员
    Vue.mixin({
      methods: {
        /**
         *
         * @param {*} text
         * @returns
         */
        $load(text = "加载中...") {
          const loading = this.$loading({
            lock: true,
            text,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          return loading;
        },
        /**
         * 询问框弹窗
         * @param {String} message
         * @param {String} type
         * @param {String} prompet
         * @param {String} confirmButtonText
         * @param {String} concalButtonText
         * @returns
         */
        $confirm_popup(
          message = "确认删除该文件？",
          type = "error",
          prompet = "警告",
          confirmButtonText = "确定删除",
          concalButtonText = "取消"
        ) {
          return new Promise((resolve) => {
            this.$confirm(message, prompet, {
              concalButtonText,
              confirmButtonText,
              type,
            })
              .then(() => {
                resolve();
              })
              .catch(() => {});
          });
        },
        $Msg_s(message = "OK") {
          this.$Message.success(message);
        },
        $Msg_e(message = "Error") {
          this.$Message.error(message);
        },
        $Msg_w(message = "Warning") {
          this.$Message.warning(message);
        },
        /**
         * 成功消息框
         * @param {String} message
         * @param {Number} duration
         * @param {Boolean} showClose
         */
        $msg_s(message = "成功", duration = 2000, showClose = true) {
          this.$message({
            type: "success",
            message,
            duration,
            showClose,
          });
        },
        /**
         * 失败消息框
         * @param {String} message
         * @param {Number} duration
         * @param {Boolean} showClose
         */
        $msg_e(message = "失败", duration = 2000, showClose = true) {
          this.$message({
            type: "error",
            message,
            duration,
            showClose,
          });
        },
        /**
         * 警告消息框
         * @param {String} message
         * @param {Number} duration
         * @param {Boolean} showClose
         */
        $msg_w(message = "警告", duration = 2000, showClose = true) {
          this.$message({
            type: "warning",
            message,
            duration,
            showClose,
          });
        },
        /**
         * 默认消息框
         * @param {String} message
         * @param {Number} duration
         * @param {Boolean} showClose
         */
        $msg(message = "提示", duration = 2000, showClose = true) {
          this.$message({
            message,
            duration,
            showClose,
          });
        },
        /**
         * 上传前验证
         */
        $beforeAvatarUpload(file) {
          // 定义可以上传的图片类型数组
          let img_type_list = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/jpg",
          ];
          // 通过数组的includes方法 判断是否包含
          const isJPG = img_type_list.includes(file.type);

          // 限制图片大小
          const isLtM = file.size / 1024 / 1024 < 20;

          if (!isJPG) {
            this.$msg_e("上传头像图片只能是 JPEG JPG PNG GIF 格式!");
          }

          if (!isLtM) {
            this.$msg_e("上传头像图片大小不能超过 20MB!");
          }

          return isJPG && isLtM;
        },
        /**
         * 尺寸
         * @param {*} size
         * @returns
         */
        $size(size = "small") {
          return size;
        },
        /**
         * 路由跳转
         * @param {*} path
         * @param {*} query
         */
        $goPage(path, query) {
          if (!path) return false;

          this.$router.push({
            path,
            query,
          });
        },
        /**
         * 返回上一页
         * @param {Number} index
         */
        $goBack(index = -1) {
          this.$router.go(index);
        },
        /**
         *
         * @returns 请求参数
         */
        $getParam() {
          return this.$route.params;
        },
        /**
         *
         * @returns 请求参数
         */
        $getQuery() {
          return this.$route.query;
        },
        /**
         * 网址
         * @returns
         */
        $Base_Url(url = "") {
          if (!url) return url;

          // 如果包含http或者https，返回 url

          if (url.indexOf("http") !== -1 || url.indexOf("https") !== -1) {
            return url;
          }

          if (process.env.NODE_ENV === "development") {
            return "http://jrapi.rjrightjob.com" + url;
          }

          return Base_Url + url;
        },
        /**
         * 上传网址
         * @returns
         */
        $Base_Upload_Url() {
          return Base_Upload_Url;
        },
        /**
         * POST 请求
         * @param {*} url
         * @param {*} params
         * @returns
         */
        $post(url, params) {
          return post(url, params);
        },
        /**
         * GET 请求
         * @param {*} url
         * @param {*} params
         * @returns
         */
        $get(url, params) {
          return get(url, params);
        },
        /**
         * md5加密
         * @param {*} string
         * @returns
         */
        $passwordMd5(string) {
          return passwordMd5(string);
        },
        /**
         * 获取本地时间
         * @param time
         * @returns {string}
         */
        $getTime(time = null) {
          if (time === null || time === undefined) {
            time = new Date().getTime() / 1000;
          }

          return new Date(parseInt(time) * 1000)
            .toLocaleString()
            .replace(/:\d{1,2}$/, " ");
        },
        /**
         * 时间戳转换为日期 --年月日
         * @param {*} time
         * @returns
         */
        $getYearTime(time = null) {
          if (time === null || time === undefined) {
            time = new Date().getTime() / 1000;
          }

          var d = new Date(parseInt(time) * 1000);
          return (
            d.getFullYear() +
            "-" +
            (d.getMonth() + 1 > 9
              ? d.getMonth() + 1
              : "0" + (d.getMonth() + 1)) +
            "-" +
            (d.getDate() > 9 ? d.getDate() : "0" + d.getDate())
          );
        },
        /**
         * 时间戳转换为日期时间 --年月日 时分秒
         * @param {*} time
         * @returns
         */
        $getDayTime(time = null) {
          if (time === null || time === undefined) {
            time = new Date().getTime() / 1000;
          }

          var now = new Date(time * 1000),
            y = now.getFullYear(),
            m = now.getMonth() + 1,
            d = now.getDate();
          return (
            y +
            "-" +
            (m < 10 ? "0" + m : m) +
            "-" +
            (d < 10 ? "0" + d : d) +
            " " +
            now.toTimeString().substr(0, 8)
          );
        },
        /**
         * 时间戳转换为日期时间 --年月日 时分秒
         * @param {*} time
         * @returns
         */
        $getHourTime(time) {
          time = this.$dateChangeTime(time);

          var now = new Date(time * 1000),
            y = now.getFullYear(),
            m = now.getMonth() + 1,
            d = now.getDate();

          return now.toTimeString().substr(0, 5);
        },
        /**
         * 日期转时间戳
         * @param {String} date
         */
        $dateChangeTime(date) {
          return parseInt(new Date(date).getTime() / 1000);
        },
        /**
         * 字符串转数组
         * @param {String} string
         * @param {String} separator
         * @param {Boolean} is_number
         * @returns
         */
        $stringToArray(string, separator = ",", is_number = true) {
          let list = [];

          string += "";

          if (new String(string).length) {
            list = string.split(separator); // 以逗号,为拆分的字符串

            if (is_number) {
              list.forEach((value, index) => {
                list[index] = parseInt(value);
              });
            }
          }

          return list;
        },
        /**
         * 数组转字符串
         * @param {Array} array
         * @param {String} separator
         */
        $arrayToString(array, separator = ",") {
          return array.join(separator); // 把数组项拼接成字符串，以逗号,分隔
        },
      },
    });
  },
};
